import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Donut } from "react-dial-knob";
import { div, Link, useNavigate } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";

const TicketSummary = () => {

    const history = useNavigate();

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    let userDetails = JSON.parse(localStorage.getItem("user_details"));

    const [data, setData] = useState(null);
    const [allDataLoaded, setAllDataLoaded] = useState(false);

    const colorDeciding = (waitingTokens) => {
        
        if (waitingTokens === 0) {
            return "#a5a8ad";
        } else if (waitingTokens <= 9) {
            return "#42deb0";
        } else if (waitingTokens >= 10 && waitingTokens <= 19) {
            return "#ffc107";
        } else {
            return "#dc3545";
        }
    }

    useEffect(() => {
        getCountry();
    }, [TicketSummary])

    useEffect(() => {
        if (data !== null) {
            const callFunction = () => {
                getCountry();
            };

            const interval = setInterval(callFunction, 60000);

            return () => clearInterval(interval);
        }
    }, [data]);

    const getCountry = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/${userDetails['bid']}/ticket-summary`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getCountry success');
            let data = res.data.data;
            setData(data);
            setAllDataLoaded(true);

        }).catch((error) => {
            console.log('getCountry error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }

    const navigateToBranchTables = (selectedBranchId, selectedBranchName, selectedBranchLevel, selectedBranchQueueType) => {
        history('/branch-dashboard', {
            state: {
                selectedBranchId: selectedBranchId,
                selectedBranchName: selectedBranchName,
                selectedBranchLevel: selectedBranchLevel,
                selectedBranchQueueType: selectedBranchQueueType
            }
        });
    }

    return (
        <>
            {!allDataLoaded ? (
                <div className="container-fluid">
                    {/* <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Ticket Summary</h2>
                        </div>
                    </div>
                </div> */}
                    <div className="row clearfix">
                        {Array.from({ length: 12 }).map((_, index) => (
                            <div className="col-lg-3 col-md-6" key={index}>
                                <ShimmerThumbnail>
                                    <div className={`card landing-page-main-cards`}>
                                        <div className="body w_knob">
                                            <div className="c_know">
                                                <div className="text-center h3 text-light-green">
                                                    {/* {data && data.totalIssuedTickets ? data.totalIssuedTickets : 0} */}
                                                </div>
                                            </div>
                                            <div className="text-right" style={{ textAlign: 'right' }}>
                                                <h6>Issued Tickets</h6>
                                            </div>
                                        </div>
                                    </div>
                                </ShimmerThumbnail>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="container-fluid">
                    {/* <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Ticket Summary</h2>
                        </div>
                    </div>
                </div> */}
                    <div className="row clearfix">
                        <div className="col-lg-3 col-md-6">
                            <div
                                className={`card landing-page-main-cards`}

                            >
                                <div className="body w_knob">
                                    <div className="c_know">
                                        <div className="text-center h3 text-light-green">
                                            {data && data.totalIssuedTickets ? data.totalIssuedTickets : 0}
                                        </div>
                                    </div>
                                    <div className="text-right" style={{ textAlign: 'right' }}>
                                        <h6>Issued Tickets</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div
                                className={`card landing-page-main-cards`}

                            >
                                <div className="body w_knob">
                                    <div className="c_know">
                                        <div className="text-center h3 text-light-green">
                                            {data && data.totalServedTickets ? data.totalServedTickets : 0}
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <h6> Served Tickets</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div
                                className={`card landing-page-main-cards`}

                            >
                                <div className="body w_knob">
                                    <div className="c_know">
                                        <div className="text-center h3 text-light-green">
                                            {data && data.totalWaitingTickets ? data.totalWaitingTickets : 0}
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <h6>Waiting Tickets</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div
                                className={`card landing-page-main-cards`}

                            >
                                <div className="body w_knob">
                                    <div className="c_know">
                                        <div className="text-center h3 text-light-green">
                                            {data && data.totalServingTickets ? data.totalServingTickets : 0}
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <h6>Serving Tickets</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {data ? <>
                            {
                                data.branchTokensSummaryList.map((item) =>
                                    <div className="col-lg-3 col-md-6 col-sm-12" key={item.branchId}>
                                        <div className="card" style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                if (item.branchQueueType !== null) {
                                                    navigateToBranchTables(item.branchId, item.branchName, item.branchLevel, item.branchQueueType)
                                                } else {
                                                    toast.remove();
                                                    toast.error('Branch Queue Type Not Defined', {
                                                        position: 'bottom-center',
                                                    });
                                                }
                                            }}
                                        >
                                            <div className="body">
                                                <div className="row text-center">
                                                    <div className="col-lg-12 col-md-5">
                                                        <label className="mb-3 h4">{item.branchName}</label>
                                                        <div className="text-center d-flex justify-content-center">
                                                            <Donut
                                                                className="knob"
                                                                diameter={73}
                                                                step={1}
                                                                value={item.waitingCount}
                                                                theme={{
                                                                    donutThickness: 3,
                                                                    donutColor: colorDeciding(item.waitingCount),
                                                                    centerColor: "#282B2F",
                                                                    bgrColor: '#383b40'
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="row clearfix">
                                                            <div className="col-6">
                                                                <label className="mb-0 mt-2">Issued</label>
                                                                <h4 className={`h4 mb-0 font-weight-bold ${item.issuedCount > 0 ? 'text-cyan': ''} `}>{item.issuedCount}</h4>
                                                            </div>
                                                            <div className="col-6">
                                                                <label className="mb-0 mt-2">Served</label>
                                                                <h4 className={`h4 mb-0 font-weight-bold ${item.servedCount > 0 ? 'text-cyan' : ''} `}>{item.servedCount}</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </> : null}
                    </div>
                </div>
            )}
        </>
    )
}

export default TicketSummary